// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReportFilterDto } from './IReportFilterDto';
import {
    IReportFilterDtoFromJSON,
    IReportFilterDtoFromJSONTyped,
    IReportFilterDtoToJSON,
    IReportFilterDtoToJSONTyped,
} from './IReportFilterDto';

/**
 * 
 * @export
 * @interface IReportSchedulerCreateDto
 */
export interface IReportSchedulerCreateDto {
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerCreateDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerCreateDto
     */
    report_type: IReportSchedulerCreateDtoReportTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerCreateDto
     */
    report_group_type: IReportSchedulerCreateDtoReportGroupTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IReportSchedulerCreateDto
     */
    cron: string;
    /**
     * 
     * @type {Date}
     * @memberof IReportSchedulerCreateDto
     */
    start_date: Date;
    /**
     * 
     * @type {Date}
     * @memberof IReportSchedulerCreateDto
     */
    end_date?: Date;
    /**
     * 
     * @type {IReportFilterDto}
     * @memberof IReportSchedulerCreateDto
     */
    report_filter: IReportFilterDto;
}

/**
* @export
* @enum {string}
*/
export enum IReportSchedulerCreateDtoReportTypeEnum {
    PARTICIPANT_ACCOUNT_ACTIVITY = 'PARTICIPANT_ACCOUNT_ACTIVITY',
    PAYROLL_CONTRIBUTIONS = 'PAYROLL_CONTRIBUTIONS',
    EMPLOYEE_DEMOGRAPHICS = 'EMPLOYEE_DEMOGRAPHICS',
    CLAIM_ACTIVITY = 'CLAIM_ACTIVITY',
    FORFEITURE = 'FORFEITURE',
    HEALTH_PLAN_ENROLLMENT = 'HEALTH_PLAN_ENROLLMENT',
    CARD_STATUS = 'CARD_STATUS',
    CIP_STATUS = 'CIP_STATUS',
    REPLENISHMENT_INVOICE = 'REPLENISHMENT_INVOICE',
    CONTRIBUTION_INVOICE = 'CONTRIBUTION_INVOICE',
    PREFUND_INVOICE = 'PREFUND_INVOICE',
    PLAN_OMNIBUS_BALANCE = 'PLAN_OMNIBUS_BALANCE',
    UNDELIVERABLE_ADDRESS = 'UNDELIVERABLE_ADDRESS',
    DELINQUENT_CLAIMS = 'DELINQUENT_CLAIMS'
}
/**
* @export
* @enum {string}
*/
export enum IReportSchedulerCreateDtoReportGroupTypeEnum {
    SUMMARY = 'SUMMARY',
    BREAKDOWN = 'BREAKDOWN'
}


/**
 * Check if a given object implements the IReportSchedulerCreateDto interface.
 */
export function instanceOfIReportSchedulerCreateDto(value: object): value is IReportSchedulerCreateDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('report_type' in value) || value['report_type'] === undefined) return false;
    if (!('report_group_type' in value) || value['report_group_type'] === undefined) return false;
    if (!('cron' in value) || value['cron'] === undefined) return false;
    if (!('start_date' in value) || value['start_date'] === undefined) return false;
    if (!('report_filter' in value) || value['report_filter'] === undefined) return false;
    return true;
}

export function IReportSchedulerCreateDtoFromJSON(json: any): IReportSchedulerCreateDto {
    return IReportSchedulerCreateDtoFromJSONTyped(json, false);
}

export function IReportSchedulerCreateDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReportSchedulerCreateDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'report_type': json['report_type'],
        'report_group_type': json['report_group_type'],
        'cron': json['cron'],
        'start_date': (new Date(json['start_date'])),
        'end_date': json['end_date'] == null ? undefined : (new Date(json['end_date'])),
        'report_filter': IReportFilterDtoFromJSON(json['report_filter']),
    };
}

export function IReportSchedulerCreateDtoToJSON(json: any): IReportSchedulerCreateDto {
    return IReportSchedulerCreateDtoToJSONTyped(json, false);
}

export function IReportSchedulerCreateDtoToJSONTyped(value?: IReportSchedulerCreateDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'report_type': value['report_type'],
        'report_group_type': value['report_group_type'],
        'cron': value['cron'],
        'start_date': ((value['start_date']).toISOString().substring(0,10)),
        'end_date': value['end_date'] == null ? undefined : ((value['end_date']).toISOString().substring(0,10)),
        'report_filter': IReportFilterDtoToJSON(value['report_filter']),
    };
}

